<template>
  <v-container>
   <v-divider></v-divider>
   <v-form ref="form" v-model="component.validPersonal">
     <v-row>
       <v-col>
         <v-text-field
           v-model="component.physicalClient.motherName"
           label="Nome da Mãe"
           outlined
           required
         >
         </v-text-field>
       </v-col>
       <v-col>
         <v-text-field
           v-model="component.physicalClient.fatherName"
           label="Nome do Pai"
           outlined
           required
         >
         </v-text-field>
       </v-col>
     </v-row>
     <v-row>
       <v-col>
         <v-select
           label="*Gênero"
           outlined
           v-model="component.physicalClient.gender"
           :items="items_gender"
           :rules="[() => !!component.physicalClient.gender || 'Campo Obrigatorio']"
         >
         </v-select>
       </v-col>
       <v-col>
         <v-text-field
           v-model="component.physicalClient.monthlyIncome"
           label="Renda Mensal"
           outlined
           @input="applyMoneyMask('monthlyIncome', $event)"
           placeholder="R$ 0,00"
           required
         >
         </v-text-field>
       </v-col>
     </v-row>
     <v-row>
       <v-col cols="3">
         <v-select
           v-model="component.physicalClient.civilStatus"
           label="*Estado Civil"
           :items="civilStatus"
           outlined
           @blur="checkCivilStatus()"
         >
         </v-select>
       </v-col>
       <v-col cols="6">
         <v-text-field
           v-model="component.physicalClient.spouse"
           label="Cônjugue"
           outlined
           required
         >
         </v-text-field>
       </v-col>
       <v-col>
         <v-text-field
           v-model="component.physicalClient.icomeSpouse"
           label="Renda Conjugal"
           outlined
           @input="applyMoneyMask('icomeSpouse', $event)"
           placeholder="R$ 0,00"
         >
         </v-text-field>
       </v-col>
     </v-row>
   </v-form>
  </v-container>
 </template>
 
 <script>
 import { GENDER_OPTIONS } from "@/utils/enums/gender";

 export default {
   props: {
     component: Object(),
   },
   data: () => ({
     items_gender: GENDER_OPTIONS,
     civilStatus: ["Casado(a)", "Divorciado(a)", "Solteiro(a)", "Viúvo(a)"],
   }),

   methods: {
    checkCivilStatus() {
      if(this.component.physicalClient.civilStatus == "") {
        this.component.physicalClient.civilStatus = "Solteiro(a)"
      }
    },
    applyMoneyMask(fieldName, value) {
      let numericValue = value.replace(/\D/g, '');
      
      if (numericValue === '') {
        this.component.physicalClient[fieldName] = '';
        return;
      }
      
      let intValue = parseInt(numericValue);
      let formattedValue = (intValue / 100).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      });
      
      this.component.physicalClient[fieldName] = formattedValue;
    }
   },
 };
 </script>
 
 <style>
 </style>